import palette from '../palette';

export const MuiMenuItem = {
  styleOverrides: {
    root: {
      '&:hover': {
        backgroundColor: palette.primary.hoverNavy,
      },
      '&:focus': {
        backgroundColor: palette.primary.hoverNavy,
      },
      '&.Mui-selected': {
        backgroundColor: palette.primary.hoverNavyDark,
        '&:focus-visible': {
          backgroundColor: palette.primary.hoverNavyDark,
        },
        '&:hover': {
          backgroundColor: palette.primary.hoverNavyDark,
        },
      },
    },
  },
};
